let poly = require('preact-cli/lib/lib/webpack/polyfills')

import { h } from 'preact'
import habitat from 'preact-habitat'
import './index.scss'
import Widget from './components/App'

let _habitat = habitat(Widget)

_habitat.render({
    selector: '#easyms-reservation-module',
    clean: true
})



// WEBPACK FOOTER //
// ./index.js